var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.91 4.882a.6.6 0 01.71-.47c.32.07.53.38.47.71l-2 10a.6.6 0 01-.59.48h-12a.6.6 0 01-.59-.48l-1.904-9.52H2.5c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6H5.44a.607.607 0 01.649.48l1.9 9.52h11.02l1.9-9.52zM11 18.102c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zm8 0c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zm-.5-12.3h-10c-.28 0-.5.22-.5.5s.22.5.5.5h10c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM9 8.602h9c.28 0 .5.22.5.5s-.22.5-.5.5H9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zm.5 2.8h8c.28 0 .5.22.5.5s-.22.5-.5.5h-8c-.28 0-.5-.23-.5-.5s.22-.5.5-.5z"
  })));
}

export default SvgCart;